import { render, staticRenderFns } from "./CreateFileDrop.vue?vue&type=template&id=700c25ac&"
import script from "./CreateFileDrop.vue?vue&type=script&lang=js&"
export * from "./CreateFileDrop.vue?vue&type=script&lang=js&"
import style0 from "./CreateFileDrop.vue?vue&type=style&index=0&id=700c25ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VProgressCircular,VTextField})
